var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    { staticClass: "view-overview-period" },
    [
      _c("ui-heading", {
        attrs: { title: "Overzicht per periode", icon: "magicon-calendar" },
      }),
      _c("ui-panel", { staticClass: "overview-settings" }, [
        _c("div", { staticClass: "dates" }, [
          _c(
            "div",
            { staticClass: "start-date" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("Startdatum")]),
              _c("ui-date-input", {
                model: {
                  value: _vm.startDate,
                  callback: function ($$v) {
                    _vm.startDate = $$v
                  },
                  expression: "startDate",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "start-date" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("Einddatum")]),
              _c("ui-date-input", {
                model: {
                  value: _vm.endDate,
                  callback: function ($$v) {
                    _vm.endDate = $$v
                  },
                  expression: "endDate",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "filter" },
          [
            _c("span", { staticClass: "label" }, [_vm._v("Pas filters toe")]),
            _c("ui-filter-button", {
              attrs: { options: _vm.filterOptions },
              model: {
                value: _vm.filters,
                callback: function ($$v) {
                  _vm.filters = $$v
                },
                expression: "filters",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "create" },
          [
            _c(
              "ui-button",
              {
                attrs: {
                  color: "positive",
                  icon: "magicon-reload-2",
                  loading: _vm.execute,
                },
                on: {
                  click: function ($event) {
                    _vm.execute = true
                  },
                },
              },
              [_vm._v("Creëer overzicht")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "results spinner-fill has-spinner" },
        [
          _vm.parcels != null && !_vm.filteredParcels.length
            ? _c("span", { staticClass: "placeholder-full" }, [
                _vm._v("Er zijn geen resultaten gevonden"),
              ])
            : _vm._l(_vm.filteredParcels, function (parcel) {
                return _c("pm-parcel-detail", {
                  key: parcel.id,
                  attrs: {
                    parcel: parcel,
                    sections: parcel.sections.items,
                    collapsible: "",
                    type: _vm.filters.type,
                    "start-date": _vm.startDate,
                    "end-date": _vm.endDate,
                  },
                })
              }),
          _c("core-spinner", {
            attrs: { visible: _vm.loading, overlay: _vm.parcels !== null },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }